import http from '../_http_v2';

const pattern = {
  //default
  list: (m) => { return http.post(`console/wmds/pattern/list`, m); },
  detail: (m) => { return http.post(`console/wmds/pattern/${m.id}`, m); },

  //crud
  insert: (m) => { return http.post(`console/wmds/pattern`, m); },
  update: (m) => { return http.put(`console/wmds/pattern`, m); },
  delete: (m) => { return http.delete(`console/wmds/pattern/${m.id}`); },

  //latest
  latest: (m) => { return http.get(`console/wmds/pattern/latest`, m); }
}

export default pattern

export { pattern }